import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  padding: 8px 0px 16px 0px;
`;

export const ToggleContainer = styled.div`
  width: 100%;
`;

export const InfoText = styled.div`
  width: 100%;

  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textSmallHeight16};
`;
